import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { ContestStatusComponent } from './contest-status.component';

@NgModule({
  imports: [CommonModule, UiModule],
  declarations: [ContestStatusComponent],
  exports: [ContestStatusComponent],
})
export class ContestStatusModule {}
